import { Modal, Form, Select, Switch } from 'antd';

import '../styles/CreateTemplateModal.desktop.scss';
import { CANCEL, SAVE } from '@app/constants';

import type { CreateTemplateModalProps } from '../types';

export const CreateTemplateModal = ({
  open,
  onCancel,
  onCreate,
}: CreateTemplateModalProps) => {
  const [form] = Form.useForm();

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      onOk={() => form.submit()}
      okText={SAVE}
      cancelText={CANCEL}
      title="Создать протокол"
      centered
      className="create-protocol-modal"
    >
      <Form form={form} layout="vertical" onFinish={onCreate}>
        <Form.Item
          label="Тип протокола"
          name="protocolType"
          rules={[{ required: true }]}
        >
          <Select
            placeholder="Выберите тип"
            options={[
              {
                value: 'inspection',
                label: 'Протокол осмотра (СЭМД 119)',
              },
            ]}
          />
        </Form.Item>

        <Form.Item
          name="isBasedOnPrevious"
          valuePropName="checked"
          className="switch-item"
        >
          <div className="switch-wrapper">
            <Switch />
            <span>На основе предыдущего протокола</span>
          </div>
        </Form.Item>

        <Form.Item label="Шаблон протокола" name="template">
          <Select
            placeholder="Без шаблона"
            options={[{ value: 'none', label: 'Без шаблона' }]}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
